export enum MenuItems {
    home,
    learn,
    play,
    test,
    team,
    course,
    tournament,
    learningPath,
    skillTree,
    quiz,
    'contact-support',
    discover
}

export enum SubMenuItems {
    all = 0,
    'assigned-content' = 1,
    'career-journey' = 2,
    'recently-added' = 3,
    'others-are-taking' = 4,
    'monthly-videos' = 5
}

export interface LeftMenuProps {
    selectedItem: keyof typeof MenuItems;
    onClick: Function;
}
